"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FocusProvider = void 0;
var react_1 = __importDefault(require("react"));
var utils_1 = require("../utils");
var FocusProvider = function (_a) {
    var children = _a.children, search = _a.search, header = _a.header, options = _a.options, preventFocus = _a.preventFocus;
    var initialState = utils_1.getInitialState(search, header, options, preventFocus);
    var _b = react_1.default.useReducer(utils_1.focusReducer, initialState), state = _b[0], dispatch = _b[1];
    return (react_1.default.createElement(utils_1.FocusContext.Provider, { value: { focusState: state, focusDispatch: dispatch } }, children));
};
exports.FocusProvider = FocusProvider;
//# sourceMappingURL=FocusProvider.js.map